import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import FormHelper from '../../../../utils/FormHelper'
import PageForm from '../components/form/form.component'
import CreatePageWorker from './create'
import './create.styles.scss'

class CreatePage extends React.Component {

    constructor(props) {
        super(props)
        this.createPageWorker = CreatePageWorker(this)
        this.state = this.createPageWorker.getDefaultState()
    }

    onSubmit = (event) => {
        event.preventDefault()
        if (!this.createPageWorker.isValid()) {
            return
        }

        this.createPageWorker.createPage()
    }

    onCancel = (event) => {
        event.preventDefault()
        this.props.history.push('/content/pages')
    }

    render() {
        return (
            <div className="create-page">
                {
                    this.state.creatingPage && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/pages">Pages</Link>
                    <div className="header">
                        <h4>Create Page</h4>
                    </div>

                    <div className={"flag " + this.state.flag.type}>{this.state.flag.text}</div>

                    <PageForm
                        {...this.state}
                        action="Add Page"
                        submitting={this.state.creatingPage}
                        onChange={FormHelper(this).onChange}
                        onSubmit={this.onSubmit}
                        onCancel={this.onCancel}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(CreatePage)
